import { createSlice, createSelector } from '@reduxjs/toolkit'
import qs from 'qs'

const initialState = {
  results: {},
  barcodeResult: null,
  loaded: false,
  loading: false,
  error: null,
  errorPage: null,
  loadingPage: false,
  currentQuery: null,
  data: {},
}

const search = createSlice({
  name: 'search',
  initialState: initialState,
  reducers: {
    requestSearch(state) {
      state.loading = true
      state.loaded = false
    },
    requestNewSearch(state) {
      state.loading = true
    },
    successSearch(state, { payload }) {
      state.results = payload
      state.loading = false
      state.loaded = true
      state.error = null
    },
    failureSearch(state, { payload }) {
      state.loading = false
      state.error = payload
    },
    resetSearch(state) {
      state.results = []
      state.loaded = false
    },
    requestBarcode(state) {
      state.loading = true
      state.loaded = false
    },
    successBarcode(state, { payload }) {
      state.barcodeResult = payload
      state.loading = false
      state.loaded = true
      state.error = null
    },
    failureBarcode(state, { payload }) {
      state.loading = false
      state.error = payload
    },
    resetBarcode(state) {
      state.barcodeResult = []
      state.loaded = false
      state.error = null
    },
    requestSearchPage(state) {
      state.loadingPage = true
    },
    successSearchPage(state, { payload }) {
      const { key, response, refresh } = payload
      const { data } = state

      state.currentQuery = key

      if (response) {
        if (refresh) {
          state.data = { [key]: response || data[key] }
        } else if (!data[key]?.result) {
          state.data[key] = response || data[key]
        }
      }

      state.loadingPage = false
      state.errorPage = null
      state.loaded = true
    },
    failureSearchPage(state, { payload }) {
      state.currentQuery = payload.key
      state.loadingPage = false
      state.errorPage = payload.response
      state.loaded = true
    },
    resetSearchPage(state) {
      state.loaded = false
      state.data = {}
      state.errorPage = null
    },
  },
})

export const fetchSearchResults =
  ({ query, onSuccess }) =>
    async (dispatch, getState, { api }) => {
      try {
        dispatch(requestSearch())

        const response = await api.search({ query })

        const { result, data } = response
        if (result === 'success') {
          dispatch(successSearch(data))
          onSuccess?.(data)
        } else {
          dispatch(failureSearch(data))
        }
      } catch (err) {
        dispatch(failureSearch(err.toString()))
      }
    }

export const newFetchSearchResults =
  ({ query, onSuccess }) =>
    async (dispatch, getState, { api }) => {
      try {
        dispatch(requestNewSearch())

        const response = await api.newSearch({ q: query })

        const { result, data } = response
        if (result === 'success') {
          dispatch(successSearch(data))
          onSuccess?.(data)
        } else {
          dispatch(failureSearch(data))
        }
      } catch (err) {
        dispatch(failureSearch(err.toString()))
      }
    }

export const fetchSearchPageResults =
  ({ onSuccess, onError, refresh = false, ...params }) =>
    async (dispatch, getState, { api }) => {
      const state = getState().search
      const key = qs.stringify(params)

      try {
        if (!refresh && state.data[key]) {
          dispatch(successSearchPage({ key, refresh }))
          if (onSuccess) onSuccess(state.data[key])
        } else {
          dispatch(requestSearchPage())
          const response = await api.searchPage(params)
          const { result } = response
          if (result === 'success') {
            dispatch(successSearchPage({ response, key, refresh }))
            onSuccess?.(response)
          } else {
            dispatch(failureSearchPage({ response, key }))
            onError?.(response)
          }
        }
      } catch (err) {
        dispatch(failureSearchPage({ response: err.toString(), key }))
        onError?.(err)
      }
    }

export const fetchBarcodeResult =
  ({ originalError = false, barcode }) =>
    async (dispatch, getState, { api }) => {
      try {
        dispatch(requestBarcode())

        const response = await api.catalogSearch({ barcode })

        const { result, data } = response
        if (result === 'success' && data?.length > 0) {
          dispatch(successBarcode(data))
        } else {
          dispatch(failureBarcode('Товар не найден'))
        }
        return data
      } catch (err) {
        dispatch(failureBarcode(originalError ? err : err.toString()))
      }
    }

export const getSearchData = createSelector(
  state => state.search,
  search => {
    return {
      ...search,
    }
  },
)

export const getSearchPageData = createSelector(
  state => state.search,
  search => {
    const { data, loadingPage, errorPage, loaded } = search

    return {
      data: data[search.currentQuery],
      loading: loadingPage,
      loaded,
      error: errorPage,
    }
  },
)

export const {
  requestSearch,
  requestNewSearch,
  successSearch,
  failureSearch,
  requestSearchPage,
  successSearchPage,
  failureSearchPage,
  resetSearchPage,
  resetSearch,
  requestBarcode,
  successBarcode,
  failureBarcode,
  resetBarcode,
} = search.actions

export default search.reducer
